'use strict';

class InputManager {
  constructor(renderer, handler) {
    this.renderer = renderer;
    this.canvas = renderer.canvas;
    this.handler = handler;
    this.activePointerId = null;
    this.lastX = 0;
    this.lastY = 0;
    this.keys = new Set();
    this.listeners = [];
    this.bindEvents();
  }

  bindEvents() {
    this.listen(this.canvas, 'pointerdown', (event) => this.handlePointer('start', event));
    this.listen(this.canvas, 'pointermove', (event) => this.handlePointer('move', event));
    this.listen(this.canvas, 'pointerup', (event) => this.handlePointer('end', event));
    this.listen(this.canvas, 'pointercancel', (event) => this.handlePointer('cancel', event));
    this.listen(window, 'keydown', (event) => this.handleKey(event, true));
    this.listen(window, 'keyup', (event) => this.handleKey(event, false));
    this.listen(window, 'blur', () => this.keys.clear());
  }

  listen(target, type, handler) {
    target.addEventListener(type, handler, { passive: false });
    this.listeners.push({ target, type, handler });
  }

  handlePointer(type, event) {
    let dx = 0;
    let dy = 0;
    if (type === 'start') {
      if (this.activePointerId !== null) return;
      this.activePointerId = event.pointerId;
      this.lastX = event.clientX;
      this.lastY = event.clientY;
      this.canvas.setPointerCapture(event.pointerId);
    } else if (event.pointerId !== this.activePointerId) {
      return;
    } else if (type === 'move') {
      dx = event.clientX - this.lastX;
      dy = event.clientY - this.lastY;
      this.lastX = event.clientX;
      this.lastY = event.clientY;
    }
    event.preventDefault();
    const point = this.renderer.toLogicalPoint(event.clientX, event.clientY);
    this.handler(type, point, { dx, dy });
    if (type === 'end' || type === 'cancel') this.cancelPointer();
  }

  cancelPointer() {
    if (
      this.activePointerId !== null
      && this.canvas.hasPointerCapture
      && this.canvas.hasPointerCapture(this.activePointerId)
    ) {
      this.canvas.releasePointerCapture(this.activePointerId);
    }
    this.activePointerId = null;
    this.lastX = 0;
    this.lastY = 0;
  }

  handleKey(event, pressed) {
    const key = String(event && event.key || '').toLowerCase();
    if (!['arrowup', 'arrowdown', 'arrowleft', 'arrowright', 'w', 'a', 's', 'd'].includes(key)) {
      return;
    }
    event.preventDefault();
    if (pressed) this.keys.add(key);
    else this.keys.delete(key);
  }

  getKeyboardVector() {
    let x = 0;
    let y = 0;
    if (this.keys.has('arrowleft') || this.keys.has('a')) x -= 1;
    if (this.keys.has('arrowright') || this.keys.has('d')) x += 1;
    if (this.keys.has('arrowup') || this.keys.has('w')) y -= 1;
    if (this.keys.has('arrowdown') || this.keys.has('s')) y += 1;
    if (x && y) {
      const diagonal = Math.SQRT1_2;
      x *= diagonal;
      y *= diagonal;
    }
    return { x, y };
  }

  destroy() {
    this.cancelPointer();
    this.listeners.forEach(({ target, type, handler }) => {
      target.removeEventListener(type, handler);
    });
    this.listeners = [];
    this.keys.clear();
  }
}

module.exports = InputManager;
